import algoliasearch from 'algoliasearch/lite';

let algoliaClient = {};

try {
	algoliaClient = algoliasearch( MWC_AIS.app_id, MWC_AIS.frontend_key );
} catch ( e ) {
	console.warn( e.name, e.message );
	algoliaClient = {};
}

/**
 * Initialize the algolia search client and return it
 */

export const searchClient = {
	...algoliaClient, // push other clients fields to it (apiKey being the one needed for insights)

	search( requests ) {
		if ( requests.every( ( { params } ) => ! params.query ) ) {
			return Promise.resolve( {
				results: requests.map( () => ( {
					hits: [],
					nbHits: 0,
					nbPages: 0,
					page: 0,
					processingTimeMS: 0,
				} ) ),
			} );
		}

		return algoliaClient.search( requests );
	},
};
